import type { Activity, RankedActivity } from '../activities/types'
import type { Facility, RankedFacility } from '../facilities/types'

export type ActivityRanking = RankedActivity & {
  topFacility: Facility
}

export type ListActivityRankingsResponse = ActivityRanking[]

export interface GetActivityFacilityRankingResponse {
  activity: Activity
  facilities: RankedFacility[]
  aggregatedAt: string
}

export enum RankingPrevMonthComparison {
  RANK_UP = 'rank_up',
  RANK_KEEP = 'rank_keep',
  RANK_DOWN = 'rank_down',
}
